// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".c6f3adc71f41df1215f0137e7dd8f1872a19560f.chunk.bundle.js";
};